<template>
    <CqModal :showModal="show" @closeModal="closeModal" :heading="title">
        <template v-if="messages">
            <p v-for="(message, index) of messages" :key="message + '--' + index">
                {{ message }}
            </p>
        </template>
        <p class="extra-info" v-for="(item, index) in extraInfo" :key="item.message + '--' + index">
            <b class="title">{{ item.title }}:</b><br /> {{ item.message }}
        </p>
        <CqButtonBar>
            <CqButton @click="closeModal" primary :label="buttonValue" />
        </CqButtonBar>
    </CqModal>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';
    import {CqButton, CqButtonBar, CqModal} from '@cquential/ui';
    import {WarningInformation} from '@/components/modals/types';

    @Component({
        components: {
            CqButton,
            CqButtonBar,
            CqModal,
        },
    })
    export default class WarningInformationModal extends Vue {
        private static readonly DEFAULT_BUTTON_VALUE: string = 'Sluit';
        private static instance: WarningInformationModal | null;

        public show: boolean = false;
        public title: string = '';
        public messages: string[] | null = null;
        public extraInfo: WarningInformation[] = [];
        public buttonValue: string = WarningInformationModal.DEFAULT_BUTTON_VALUE;

        public mounted(): void {
            WarningInformationModal.instance = this;
        }

        public beforeUnmount(): void {
            WarningInformationModal.instance = null;
        }

        public closeModal(): void {
            this.show = false;
        }

        public static open(openMessage: string, openTitle: string, openExtraInfo?: WarningInformation[], openButtonValue?: string): void {
            this.instance!.messages = openMessage.split('\n').filter((partialMessage: string): boolean => partialMessage.length > 0);
            this.instance!.title = openTitle;
            this.instance!.extraInfo = openExtraInfo && openExtraInfo.length > 0 ? openExtraInfo : [];
            this.instance!.buttonValue = openButtonValue ? openButtonValue : WarningInformationModal.DEFAULT_BUTTON_VALUE;
            this.instance!.show = true;
        }
    }
</script>

<style lang="scss" scoped>
    .extra-info {
        .title {
            color: var(--header-bar-background-color);
        }
    }
</style>
